<template>
  <div class="chart_box">
    <div v-show="Object.keys(chartDt).length>0" class="chart_container" id="echart1"></div>
    <div v-show="Object.keys(chartDt).length==0">
      <el-empty description="暂无数据" />
    </div>
  </div>
</template>

<script setup>
  import * as echarts from 'echarts';
  import { ElEmpty } from 'element-plus';
  import { computed, nextTick, onMounted, ref, toRefs, watch } from 'vue';
  import { barLineOpt } from '../utils/echartOptions';

  const emits = defineEmits();
  const props = defineProps({
    chartDt: { type: Object, default: [] },
    xAxisData: { type: Array, default: [] },
    titleText: { type: String, default: '' },
    theadDataSort: { type: Array, default: [] },
  });
  const { chartDt, xAxisData, titleText, theadDataSort } = toRefs(props);
  let echart = null;
  let chartOpt = null;
  let chartSeriesType = ref({ bar: null, line: null });
  let boxWidth = ref(0);
  chartSeriesType.value['bar'] = {
    name: 'Evaporation',
    type: 'bar',
    barMaxWidth: 50,
    data: [],
  };
  chartSeriesType.value['line'] = {
    name: 'Temperature',
    type: 'line',
    symbol: 'diamond',
    symbolSize: 10,
    yAxisIndex: 1,
    smooth: true,
    data: [],
  };

  const loadEchart = () => {
    let dom = document.getElementById('echart1');
    echart = echarts.init(dom);

    chartOpt = Object.assign({}, barLineOpt);
    echart.setOption(chartOpt);

    // echarts 加载完成，设置可导出图片
    echart.on('finished', function () {
      let dataUrl = echart.getDataURL({
        type: 'png',
        pixelRatio: 1,
        backgroundColor: '#fff',
      });
      emits('load', dataUrl);
    });
  };

  const chartOptionData = computed(() => {
    return { chartDt: chartDt.value, xAxisData: xAxisData.value, theadDataSort: theadDataSort.value };
  });

  watch(
    () => chartOptionData.value,
    (nv) => {
      const { chartDt, xAxisData, theadDataSort } = nv;
      if (echart && chartDt && xAxisData && theadDataSort) {
        // chartOpt.title.text = titleText.value;
        chartOpt.xAxis[0]['data'] = xAxisData;
        chartOpt.series = [];
        let barArr = [];
        let lineArr = [];
        for (const key in chartDt) {
          let obj1 = chartDt[key];
          // 更改原有顺序 -- 改成按照表头的顺序显示
          obj1 &&
            theadDataSort.forEach((val) => {
              let obj = obj1[val];
              if (obj && obj != undefined) {
                let type = val.indexOf('%') < 0 ? 'bar' : 'line';
                let seriesData = Object.assign({}, chartSeriesType.value[type]);
                seriesData['name'] = obj.unit || '';
                seriesData['data'] = obj.chartData;
                // 设置y轴的最大值和分隔区间
                type == 'bar' ? barArr.push(...obj.chartData) : lineArr.push(...obj.chartData);
                chartOpt.series.push(seriesData);
              }
            });
        }
        // 当只有柱状图，没有折线图的时候，显示柱状图的分割线
        if (barArr.length > 0 && lineArr.length == 0) {
          chartOpt.yAxis[0].splitLine.show = true;
        }
        // 有柱状图、折线图，显示折线图的分割线
        if (barArr.length > 0 && lineArr.length > 0) {
          chartOpt.yAxis[0].splitLine.show = false;
        }

        if (barArr.length > 0) {
          let barMinNum = Math.min(...barArr);
          // 当柱状图的最小值大于1000，数字改成xxk的形式
          if (barMinNum > 1000) {
            chartOpt.yAxis[0].axisLabel.formatter = function (v) {
              return Number((v / 1000).toFixed(0)).toLocaleString() + 'k';
            };
          } else {
            delete chartOpt.yAxis[0].axisLabel.formatter;
          }

          // 设置柱状图的最小值
          if (barMinNum > 1000) {
            chartOpt.yAxis[0].min = function (value) {
              return (value.min - value.min * 0.2).toFixed(0);
            };
          } else {
            delete chartOpt.yAxis[0].min;
          }
        }

        echart.clear();
        echart.resize({ width: boxWidth.value });
        echart.setOption(chartOpt);
      } else {
      }
    },
    { deep: true }
  );

  onMounted(() => {
    nextTick(() => {
      boxWidth.value = document.querySelector('.chart_box').clientWidth;
      loadEchart();
    });
  });
</script>

<style lang="less" scoped>
  .chart_box,
  .chart_container {
    min-width: 310px;
    height: 400px;
    background-color: #fff;
  }
  .chart_box {
    margin: 0 15px;
  }
  .chart_container {
    width: 100%;
  }
</style>